<script>
import { mapActions, mapGetters } from 'vuex'
import { getLicenseInformations } from '../api'
import { _LOCAL_BUILD } from '../constants/global/config'
import { licenseApiMap } from '../constants/global/data'

export default {
  computed: {
    ...mapGetters([
      'userLicense'
    ]),
    // static
    licenseTypeMap () {
      return {
        'vcf': 'vcf_analysis',
        'fastq': 'fastq_analysis',
        'report': 'report_module'
      }
    }
  },
  methods: {
    ...mapActions([
      'setUserLicenseAction'
    ]),
    async setLicenseStatus () {
      const getInfoStatus = info => {
        // if ((info.max_uses >= 0) && (info.usage_count >= info.max_uses)) {
        //   return 'exceeded'
        // }
        // if (!/^1\d{4}-/.test(info.new_expiry_date) && (new Date(info.imported_at) > new Date(info.new_expiry_date))) {
        //   return 'expired'
        // }
        let status = info.status.toLowerCase()
        return ['exceeded', 'expired'].includes(status) ? status : null
      }
      const getLicenseStatus = async () => {
        if (_LOCAL_BUILD) {
          try {
            let config = this.$ls.get('userInfo')
            let response = await getLicenseInformations(config)
            let licenseInformations = response.data.data
            return {
              ...licenseInformations.license_api_usage.reduce((result, info) => ({ ...result, [info.api_name]: getInfoStatus(info) }), {}),
              last_verified_today_utc: licenseInformations.last_verified_today_utc || false
            }
          } catch (error) {
            return {
              ...Object.keys(licenseApiMap).reduce((result, api) => ({ ...result, [api]: 'invalid' }), {}),
              last_verified_today_utc: false
            }
          }
        } else {
          return {
            ...Object.keys(licenseApiMap).reduce((result, api) => ({ ...result, [api]: false }), {}),
            last_verified_today_utc: true
          }
        }
      }
      let status = await getLicenseStatus()
      this.setUserLicenseAction(status)
    },
    async checkLicenseStatus (keys, getTypes = () => null) {
      await this.setLicenseStatus()
      keys = keys instanceof Array ? keys : [keys]
      let failedType = keys.find(key => this.userLicense[key])
      if (failedType) {
        const executeMap = {
          'alert': () => {
            let msg = {
              'exceeded': this.$t('COMMON.toast.___licenseExceeded'),
              'expired': this.$t('COMMON.toast.___licenseExpired')
            }[this.userLicense[failedType]] || this.$t('COMMON.toast.___licenseInvalid')
            this.addToast('error', msg)
          },
          'redirect': () => { this.$router.push({ name: 'user', params: { tab: 'license' } }) }
        }
        let types = (getTypes(this.userLicense['last_verified_today_utc']) || Object.keys(executeMap))
        if (types.length) {
          for (let type of types) {
            executeMap[type]()
          }
        } else {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/licenseManager.vue